import { useEffect } from 'react';
import { toast, Toaster, useToasterStore } from 'react-hot-toast';

import type { NotificationProviderProps } from './types';

const MAX_NOTIFICATION_COUNT = 3;

const NotificationProvider = ({ children, toasterId }: NotificationProviderProps) => {
  const { toasts } = useToasterStore(undefined, toasterId);

  // MAX_NOTIFICATION_COUNT 이상일 경우 자동으로 오래된 Notification을 제거하는 로직
  useEffect(() => {
    toasts
      .filter(t => t.visible)
      .filter((_, i) => i >= MAX_NOTIFICATION_COUNT)
      .forEach(t => toast.dismiss(t.id));
  }, [toasts]);

  return (
    <>
      <style>
        {`
          @keyframes slideInFromLeft {
            0% {
              transform: translateX(100%);
            }
            100% {
              transform: translateX(0);
            }
          }

          @keyframes slideOutToRight {
            0% {
              transform: translateX(0);
            }
            100% {
              transform: translateX(200%);
            }
          }
        `}
      </style>
      <Toaster
        position="top-right"
        gutter={8}
        toasterId={toasterId}
        containerStyle={{ top: '108px', right: '8px' }}
      />
      {children}
    </>
  );
};

export default NotificationProvider;
